import { Component, computed, inject } from '@angular/core';
import { DashboardFrameService } from '../../dashboard-frame.service';

@Component({
	selector: 'dev-banner',
	standalone: true,
	templateUrl: './dev-banner.part.html',
	styleUrls: ['./dev-banner.part.scss']
})

export class DevBannerPart {

	private frameService = inject(DashboardFrameService);
	public isDev = computed(()=> this.frameService.config().environmentName !== 'PROD');

}